import { render } from "./D3ScatterPlot.vue?vue&type=template&id=ae4dc20a&scoped=true"
import script from "./D3ScatterPlot.vue?vue&type=script&lang=js"
export * from "./D3ScatterPlot.vue?vue&type=script&lang=js"

import "./D3ScatterPlot.vue?vue&type=style&index=0&id=ae4dc20a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae4dc20a"]])

export default __exports__